import { useEffect } from "react";

export function eur(cents, currency = "EUR") {
  if (cents == null || isNaN(cents)) return "";
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}

export function offeringPrice(o) {
  if (o?.price_cents != null) return eur(o.price_cents, o.currency || "EUR");
  if (o?.price != null) return eur(Math.round(o.price * 100), o.currency || "EUR");
  return "Auf Anfrage";
}

export const TYPE_LABELS = {
  session: "Einzelsession",
  course: "Kurs",
  product: "Produkt",
  package: "Paket",
  bundle: "Bundle",
  custom: "Individuell",
};

export function typeLabel(o) {
  return o?.type_label || TYPE_LABELS[o?.type] || o?.type || "Angebot";
}

export function initials(name) {
  if (!name) return "MW";
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");
}

// Lightweight per-page SEO without an extra dependency.
export function usePageMeta(title, description) {
  useEffect(() => {
    const prev = document.title;
    if (title) document.title = `${title} · My Within`;
    let metaEl = document.querySelector('meta[name="description"]');
    const prevDesc = metaEl?.getAttribute("content");
    if (description && metaEl) metaEl.setAttribute("content", description);
    return () => {
      document.title = prev;
      if (metaEl && prevDesc != null) metaEl.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}

export function shortDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}
